import React, { useContext, useEffect, useRef, useState } from 'react';
import { DirectionsRenderer, InfoWindowF, GoogleMap, MarkerF, useJsApiLoader, Autocomplete, Circle } from '@react-google-maps/api';

import { BreathAPIs } from '../../../../APIs/BreathAPIs';
import MapPinPriv from '../../../../Images/map-pin1.png';
import MapPinPub from '../../../../Images/map-pin.png';
import MapPinShared from '../../../../Images/map-pin2.png';
import { Modal } from 'antd';
import { ButtonCustom } from '../../../../BootstrapComponents/ButtonCustom';
import { BookingsContext } from '../BookingContext';
import styles from './style.module.css';
import BookingBar from './components/BookingsBar/BookingsBar';

import { FaSearchLocation } from "react-icons/fa";
import FavoriteIcon from '../LocationList/FavoriteIcon';
import { MdOutlineMyLocation } from "react-icons/md";


import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import MoreInfo from '../MoreInfo';
import UserDashboardChargerFilter from '../UserDashboardChargerFilter';
import { FcInfo } from "react-icons/fc";
import { toast } from 'react-toastify';
import { Button, ToastContainer } from 'react-bootstrap';
import { FaDirections } from "react-icons/fa";
import { FaBell } from "react-icons/fa";
import { FaLock } from "react-icons/fa";



const containerStyle = {
    width: '100%',
    height: '100%'
};
const libraries = ['places', 'maps'];

function MapView({ switchMapView, timeFormatAmPm, user, locations, userGroups, usersFreeChargingLocations, isGuest }) {

    //  console.log("user location: ", locations)
    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: process.env.REACT_APP_MAP_API_KEY,
        libraries
    });

    const { selectedPublicLocation, setSelectedPublicLocation, isBookingLoading, setSelectedLocation, selectedLocationObj, chargersData, bookingsData, selectedDate } = useContext(BookingsContext);

    const [map, setMap] = useState(null);
    const [center, setCenter] = useState(null);

    const [publicLocations, setPublicLocations] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const [chargers, setChargers] = useState([]);
    const [isChargersLoading, setIsChargersLoading] = useState(false);

    const [viewModal, setViewModal] = useState(false);

    const [markerPosition, setMarkerPosition] = useState(null);
    const autocompleteRef = useRef(null);
    const mapRef = useRef(null);

    const [favLocations, setFavLocations] = useState(user?.favLocation);

    const [moreInfoData, setMoreInfoData] = useState([]);

    const [viewMoreInfo, setViewMoreInfo] = useState(false);
    // const [disableTimelineBtn, setDisableTimelineBtn] = useState(false)

    const [currentPosition, setCurrentPosition] = useState(null);
    const [accuracy, setAccuracy] = useState(null);

    const [resCount, setResCount] = useState(0);
    const [nonResCount, setNonResCount] = useState(0);

    const [nonReschargersAvailable, setnonResChargersAvailable] = useState(0);
    const [nonReschargersInUse, setNonResChargersInUse] = useState(0);

    const [userInNotificationList, setUserInNotificationList] = useState(null);


    useEffect(() => {
        setFavLocations(user?.favLocation);
    }, [user?.favLocation]);

    const fetchPublicLocations = async () => {
        try {
            const res = await BreathAPIs.getPublicLocations();
            console.log("Public Locations: ", res.data);
            setPublicLocations(res.data);
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
        }
    };

    const handlePlaceSelect = () => {
        const place = autocompleteRef.current.getPlace();
        if (place.geometry && place.geometry.location) {
            const location = place.geometry.location;
            setCenter({
                lat: location.lat(),
                lng: location.lng(),
            });
            setMarkerPosition({
                lat: location.lat(),
                lng: location.lng(),
            });

            if (mapRef.current) {
                mapRef.current.panTo({
                    lat: location.lat(),
                    lng: location.lng(),
                });
            }
        }
    };

    const [zoomLevel, setZoomLevel] = useState(11);
    // console.log(user?.coordinates?.length)
    useEffect(() => {
        const defaultCenter = {
            lat: 37.09,
            lng: -95.71
        };
        const fetchLocation = () => {
            fetchPublicLocations();
            if (selectedLocationObj && selectedLocationObj?.coordinates[1] != 0 && selectedLocationObj?.coordinates[0] != 0) {
                setCenter({
                    lat: selectedLocationObj?.coordinates[1],
                    lng: selectedLocationObj?.coordinates[0],
                });
                setZoomLevel(15)
            }
            else if (navigator.geolocation) {

                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        setCenter({
                            lat: position.coords.latitude,
                            lng: position.coords.longitude,
                        });
                        setZoomLevel(15);

                        setCurrentPosition({
                            lat: position.coords.latitude,
                            lng: position.coords.longitude,
                        });
                        setAccuracy(position.coords.accuracy);
                    },
                    (error) => {
                        console.error('Error getting user location:', error);
                        toast.error(error?.message);
                        setCenter(defaultCenter);
                        if (
                            user?.coordinates?.length === 2 &&
                            (
                                user?.coordinates[0] !== 0 &&
                                user?.coordinates[1] !== 0
                            )
                        ) {
                            setCenter({
                                lat: user?.coordinates[1],
                                lng: user?.coordinates[0],
                            });
                            setZoomLevel(15)
                        }
                        else {
                            setZoomLevel(5)
                        }
                    }
                );
            }
            else if (user?.coordinates?.length === 2) {

                setCenter({
                    lat: user?.coordinates[1],
                    lng: user?.coordinates[0],
                });
                setZoomLevel(15)
            }
            else {
                console.error('Geolocation is not supported by this browser.');
                setCenter(defaultCenter);
                setZoomLevel(5)
            }
        };

        fetchLocation();
    }, []);


    const setCurrentLocation = () => {
        setZoomLevel(15);
        navigator.geolocation.getCurrentPosition(
            (position) => {

                setCenter({
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                });

                setCurrentPosition({
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                });
                setAccuracy(position.coords.accuracy);

            },
            (error) => {
                console.error('Error getting user location:', error);
                toast.error(error?.message);
            }
        );
    }

    const doesPrivateLocationExistInUserLocations = (locationId) => {
        try{
            let locationData = publicLocations.find(location => location._id === locationId);
            if (locationData?.locationType !== "PRIVATE") {
                return true
            }
            if (locations && Array.isArray(locations)) {
                return locations.some(location => location._id.toString() === locationId.toString());
            }
        }catch(error){
            console.error("Error checking private location existence: ", error);
            return false;
        }
    }

    


    const onLoad = React.useCallback(function callback(map) {
        setMap(map);
        map.setCenter(center);
    }, [center]);

    const onUnmount = React.useCallback(function callback() {
        setMap(null);
    }, []);


    const [activeMarker, setActiveMarker] = useState(null);

    const [activeLocation, setActiveLocation] = useState(null);

    const getMapURL = () => {
        if (activeLocation?.coordinates?.length == 2) {
            return `https://maps.google.com/maps?q=${activeLocation?.coordinates[1]},${activeLocation?.coordinates[0]}&hl=es`;
        }
        else {
            return '#';
        }
    }

    function roundTimeToNearest15Minutes() {
        var now = new Date();
        var minutes = now.getMinutes();
        var roundedMinutes = Math.floor(minutes / 15) * 15;
        now.setMinutes(roundedMinutes);
        now.setSeconds(0);
        return now;
    }

    const handleActiveMarker = async (marker) => {


        setViewModal(true);
        setViewMoreInfo(false);

        setnonResChargersAvailable(0);
        setNonResChargersInUse(0);


        if (marker === activeMarker) {
            return;
        }
        setResCount(0);
        setNonResCount(0);
        console.log("did not return")


        try {
            const filteredLocations = publicLocations.filter(location => location._id === marker);
            setChargers([]);

            if (filteredLocations.length) {
                setIsChargersLoading(true);
                try {
                    const fetchedChargers = await BreathAPIs.getChargerByLocation(filteredLocations[0]._id, roundTimeToNearest15Minutes(new Date()));
                    // console.log("fetchedChargers data: ", fetchedChargers.data.availableConnectors)
                    let sortedChargers = fetchedChargers.data.availableConnectors.sort((a, b) => a.charger.orderingNumber - b.charger.orderingNumber);
                    if (Array.isArray(sortedChargers)) {
                        setChargers(sortedChargers);
                        // console.log("sortedChargers data: ", sortedChargers)
                        sortedChargers.forEach((charger) => {
                            if (charger.nonReservable) {
                                setNonResCount((prevCount) => prevCount + 1);
                                if (charger.connectorAvailabilty === true && charger.chargerStatus === 'Online') {
                                    if (charger.status === 'Available') {
                                        setnonResChargersAvailable((prevCount) => prevCount + 1);

                                    } else {
                                        setNonResChargersInUse((prevCount) => prevCount + 1);
                                    }
                                }
                            } else {
                                setResCount((prevCount) => prevCount + 1);
                            }
                        });
                    } else {
                        console.error("Fetched chargers data is not an array:", fetchedChargers.data);
                    }

                    setIsChargersLoading(false);
                } catch (apiError) {
                    console.error("API request error:", apiError);
                    // You can handle API request errors here, e.g., show a notification to the user
                    setIsChargersLoading(false);
                }
            }

            if (filteredLocations.length && filteredLocations[0].active === false) {
                checkUserInNotificationList(filteredLocations[0]._id);
            }

            setActiveLocation(filteredLocations.length ? filteredLocations[0] : null);
            setActiveMarker(marker);
        } catch (error) {
            console.error("An error occurred while handling active marker:", error);
            // You can add additional error handling logic here if needed
        }
    };

    const makeSelection = () => {
        console.log("active location selected from public view: ", activeLocation)
        setSelectedPublicLocation(activeMarker ? activeLocation : null);
        switchMapView();
        localStorage.setItem('selectedLocation', activeLocation?._id);
        setSelectedLocation(activeLocation?._id)

    }

    const isFavorite = (locationId) => {
        return favLocations?.some((location) => location._id === locationId);
    };

    const checkUserInNotificationList = async (locationId) => {
        try {
            const res = await BreathAPIs.checkUserInNotificationList(locationId);
            if (res.data) {
                setUserInNotificationList(res.data.msg);
            }
            // console.log("res data for checking user in notification list: ", res.data)
            // return res.data;
        } catch (error) {
            console.log("error data: ", error)
            toast.error(error?.message);
        }
    }

    const addToNotificationList = async (locationId) => {
        try {
            const res = await BreathAPIs.addUserToNotificationList(locationId);
            console.log("res data: ", res.data)
            toast.success("You are in the waiting list for this location");
            checkUserInNotificationList(locationId);
        } catch (error) {
            console.log("error data: ", error)
            toast.error(error?.message);
        }
    }

    useEffect(() => {
        if (viewModal && chargers) {
            const {
                chargingStations,
                chargingStationsNonReservable,
                chargingStationsNonReservableOffline
            } = UserDashboardChargerFilter(chargers, [activeLocation], locations, selectedDate, [])
            setMoreInfoData({
                activeLocation,
                userGroups,
                chargingStations,
                chargingStationsNonReservable,
                chargingStationsNonReservableOffline,
                usersFreeChargingLocations
            })
        }
    }, [viewModal, chargers, resCount, nonResCount])


    if (isGuest) {
        return (
            <div className={styles['is-loading']}>
                <div className='text-center'>Map view is not available for guest users.</div>
            </div>
        );
    }

    return (isLoaded && !isLoading) ? (
        <>
            <ToastContainer></ToastContainer>
            <div className={styles['location-search']}>
                <button onClick={setCurrentLocation} className={styles['current-location-btn']}><MdOutlineMyLocation /></button>
                <div className={styles['location-search-container']}>

                    <FaSearchLocation />
                    <Autocomplete
                        onLoad={(autocomplete) => (autocompleteRef.current = autocomplete)}
                        onPlaceChanged={handlePlaceSelect}
                    >
                        <input
                            type="text"
                            placeholder="Search"
                        // style={{ width: '300px', padding: '10px' }}
                        />
                    </Autocomplete>
                </div>

            </div>

            <GoogleMap
                mapContainerStyle={containerStyle}
                center={center}
                zoom={zoomLevel}
                onLoad={onLoad}
                onUnmount={onUnmount}
                options={{
                    zoomControl: false,
                    streetViewControl: false,
                    mapTypeControl: false,
                    fullscreenControl: false,
                }}
            >
                {markerPosition && <MarkerF position={markerPosition} />}

                {publicLocations?.map(({ _id, locationName, coordinates, address, public: isPublic, locationType }) => (
                    <MarkerF
                        key={_id}
                        position={{ lat: coordinates[1], lng: coordinates[0] }}
                        onClick={() => handleActiveMarker(_id)}
                        icon={{
                            url: locationType === "PUBLIC" ? MapPinPub : (locationType === "PRIVATE" ? MapPinPriv : MapPinShared),
                            scaledSize: { width: 30, height: 45 }
                        }}
                    />
                ))}

                {currentPosition && (
                    <MarkerF
                        position={currentPosition}
                        icon={{
                            path: window.google.maps.SymbolPath.CIRCLE,
                            scale: 8,
                            fillColor: '#4285F4',
                            fillOpacity: 1,
                            strokeWeight: 2,
                            strokeColor: 'white',
                        }}
                        title="Your Current Location"
                        zIndex={10}
                    />
                )}

                {currentPosition && accuracy && (
                    <Circle
                        center={currentPosition}
                        radius={accuracy}
                        options={{
                            fillColor: '#4285F4',
                            fillOpacity: 0.2,
                            strokeColor: '#4285F4',
                            strokeOpacity: 0.4,
                            strokeWeight: 1,
                        }}
                    />
                )}
            </GoogleMap>

            <Modal open={viewModal} onCancel={() => { setViewModal(!viewModal) }} footer={null}>
                {console.log("RES NON RES COUNT:", resCount, nonResCount)}
                <h4 className={styles['location-title']}>{activeLocation?.locationName}
                    {doesPrivateLocationExistInUserLocations(activeLocation?._id) ?  <span className={styles['fav']}>
                        <FavoriteIcon isFavorite={isFavorite(activeLocation?._id)} locationId={activeLocation?._id} resultFavLocations={(resultFavLocations) => {
                            setFavLocations(resultFavLocations);
                        }} />
                    </span> : <></>}
                </h4>


                <div className={styles['charger-location']}><a target='_blank' href={getMapURL()}>{activeLocation?.address?.city}, {activeLocation?.address?.state}, {activeLocation?.address?.country}</a></div>

                {doesPrivateLocationExistInUserLocations(activeLocation?._id) ? 
                    (activeLocation?.active === true && !isChargersLoading) ? <div className={styles['charger-view']}>
                        {resCount !== 0 && <div className={styles['main-title']}>{viewMoreInfo ? 'MORE INFO' : 'CHARGERS'} {viewMoreInfo ? <button onClick={() => { setViewMoreInfo(!viewMoreInfo) }}>{viewMoreInfo ? 'Show Chargers' : 'Show More Info'}</button> : <FcInfo style={{ fontSize: '20px', cursor: 'pointer' }} onClick={() => { setViewMoreInfo(!viewMoreInfo) }} />}</div>}
                        <div className={styles['charger-list-container']}>
                            {isChargersLoading && <div className="card-body"> <p className={`card-text placeholder-glow`}><span className="placeholder col-12 rounded"></span> </p> </div>}


                            {((viewMoreInfo || resCount === 0) && !isChargersLoading) ?
                                <>

                                    {moreInfoData?.activeLocation && <MoreInfo
                                        freeTime={''}
                                        rate={'$0.35'}
                                        idleFees={`${moreInfoData?.activeLocation?.idleFee}`}
                                        locationData={[moreInfoData?.activeLocation]}
                                        chargerData={moreInfoData?.chargingStations?.length > 0 ? moreInfoData?.chargingStations : moreInfoData?.chargingStationsNonReservable}
                                        userGroups={moreInfoData.userGroups}
                                        usersFreeChargingLocations={moreInfoData.usersFreeChargingLocations}
                                        allChargingStations={[...moreInfoData?.chargingStationsNonReservable, ...moreInfoData?.chargingStationsNonReservableOffline, ...moreInfoData?.chargingStations]}
                                        view={'normal'}
                                        nonResDis={resCount === 0 ? true : false}
                                    />}

                                </>
                                :
                                <>
                                    {(!isChargersLoading && chargers) && chargers.map((charger) => (
                                        <div key={charger._id} onClick={makeSelection}>
                                            <BookingBar timeFormatAmPm={timeFormatAmPm} connector={charger} />
                                        </div>

                                    ))}
                                </>
                            }


                            {(!isChargersLoading && chargers.length == 0) && <div className='mt-3 text-center mb-3'>No chargers are available.</div>}
                        </div>
                    </div>
                        :
                        (!isChargersLoading) && (<div className={styles['breathe-card']}>

                            <div className={styles['breathe-pulse']} />

                            <div className={styles['breathe-content']}>
                                <span className={styles['breathe-brand']}>Charging Reimagined</span>
                                <h3 className={styles['breathe-headline']}>BREATHE EV</h3>
                                <span className={styles['breathe-status']}>Coming Soon</span>
                            </div>
                        </div>)

                    : <div className={styles['access-card']}>

                        <div className={styles['access-pulse']} />

                        <div className={styles['access-content']}>
                            <FaLock className={styles['access-icon']} />
                            <h3 className={styles['access-headline']}>ACCESS REQUIRED</h3>
                            <span className={styles['access-status']}>Contact Property Management for access</span>
                        </div>
                    </div>
                }
                {/* {console.log("activeLocation?.active : ", activeLocation)} */}
                {   doesPrivateLocationExistInUserLocations(activeLocation?._id) ? 
                    (isChargersLoading ?
                        <div className="card-body"> <p className={`card-text placeholder-glow`}><span className="placeholder col-12 rounded"></span> </p> </div>
                        :
                        (activeLocation?.active === true ?
                            (!isChargersLoading && chargers.length != 0) &&
                            <div className={styles['button-modal-container']}>
                                <div className='text-center mt-4'>
                                    {isBookingLoading ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> :
                                        <Button className={styles['active-pin-button']} onClick={makeSelection}>
                                            Find a Time to Charge
                                        </Button>}
                                </div>
                                <div>
                                    <Button className={styles['active-pin-button']} onClick={() => { window.open(getMapURL(), '_blank') }}> Get Directions <FaDirections /></Button>
                                </div>
                            </div>
                            :
                            <div className='text-center mt-4'>
                                {(userInNotificationList || locations?.map((loc) => loc._id).includes(activeLocation?._id)) ? <span className={styles['user-in-notification-list-text']}>You will be notified when this location is live</span> : <Button onClick={() => addToNotificationList(activeLocation?._id)} className={styles['notify-me-button']}>Notify Me  <FaBell /></Button>}
                            </div>))
                    : <></>
                }
            </Modal>


        </>

    ) :
        (
            <div className={styles['is-loading']}>
                <div className="spinner-grow" role="status">
                    <span className="sr-only">Loading...</span>
                </div>
            </div>
        );

}

// export default React.memo(MapView);


MapView.propTypes = {
    user: PropTypes.object,
    locations: PropTypes.object,
    userGroups: PropTypes.array,
    usersFreeChargingLocations: PropTypes.array,
    isGuest: PropTypes.bool,


};

const mapStateToProps = (state) => ({
    user: state.auth && state.auth.user ? state.auth.user : null,
    locations: state.auth && state.auth.user ? state.auth.user.location : [],
    userGroups: state.auth && state.auth.user ? state.auth.user.userGroups : [],
    usersFreeChargingLocations: state.auth && state.auth.user ? state.auth.user.freeChargingAllowedLocations : [],
    isGuest: state.auth && state.auth.user ? state.auth.user.isGuest : false,


});

export default connect(mapStateToProps)(MapView);

